import { Tooltip } from "./Tooltip";

const countTooltip = (count) => {
	const numericCount = Number(count);
	if (!Number.isFinite(numericCount)) return "Loading matched MRs";
	return `${numericCount} matched ${numericCount === 1 ? "MR" : "MRs"}`;
};

export const CountChip = ({ count, tooltip }) => (
	<Tooltip
		content={tooltip || countTooltip(count)}
		className="pointer-events-auto"
	>
		<span className="inline-flex h-5 min-w-[1.25rem] shrink-0 items-center justify-center rounded-full border border-[var(--color-border)] bg-[var(--color-bg-secondary)] px-1.5 text-center text-sm font-medium tabular-nums text-[var(--color-text-secondary)]">
			{count}
		</span>
	</Tooltip>
);
